import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const SearchWrapper = styled.div`
  margin-bottom: ${Spacing.S8};
  position: relative;
  z-index: 1;
`
